import { api } from "boot/axios";

export default () => {
  //consolidating Breakout Up
  const consolidatingUpBreakout = async () => {
    try {
      const data = await api.get("/data/breakout-stocks/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //consolidating Breakout Down
  const consolidatingDownBreakout = async (days) => {
    try {
      const data = await api.get(`/data/downside-stocks/?days=${days}`);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Insidebar Up Breakout
  const insidebarUpBreakout = async (date) => {
    try {
      const data = await api.get(
        `/data/insidebar-stocks/?breakout_type=up&date=${date}`
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Insidebar Down Breakout
  const insidebarDownBreakout = async (date) => {
    try {
      const data = await api.get(
        `/data/insidebar-stocks/?breakout_type=down&date=${date}`
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  return {
    consolidatingUpBreakout,
    consolidatingDownBreakout,
    insidebarUpBreakout,
    insidebarDownBreakout,
  };
};
